import React from 'react';
import CareMapprButton from './CareMapprButton';

import './button.css';

interface CareMapprIconButtonProps {
  icon: React.ReactNode;
  onClick: (e: React.MouseEvent) => void;
  className?: string;
  disabled?: boolean;
}
const CareMapprIconButton = ({
  icon,
  onClick,
  className = '',
  disabled = false,
}: CareMapprIconButtonProps) => {
  return (
    <CareMapprButton
      extraClassNames={`icon-button ${className}`}
      endIcon={icon || null}
      variant="transparent"
      onClick={onClick}
      disabled={disabled}
    />
  );
};

export default CareMapprIconButton;
